angular.module('ciApp').component('noRoute', {
  //templateUrl: './app/noRoute/noRoute.html',
  template: '<p>404</p>',
  controller: function() {}
});



// WEBPACK FOOTER //
// ./app/noRoute/noRoute.component.js